module.exports = __webpack_public_path__ + "static/media/planta1.de0db5c6.png";